{
  "nav": {
    "home": "Home",
    "mobileHomes": "Mobile homes",
    "products": "Other products",
    "about": "About us",
    "contact": "Contact",
    "blog": "Blog",
    "enquire": "Enquire now",
    "openMenu": "Open menu",
    "closeMenu": "Close menu"
  },
  "common": {
    "readMore": "Read more",
    "submit": "Submit",
    "cancel": "Cancel",
    "loading": "Loading...",
    "error": "An error occurred",
    "success": "Success",
    "search": "Search",
    "title": "Translation Example",
    "examples": "Translation Examples",
    "key": "Key",
    "translation": "Translation",
    "currentLanguage": "Current Language"
  },
  "contact": {
    "loading": "Loading contact information...",
    "title": "Contact",
    "intro": "Have a project in mind? Send us an enquiry, and we'll be in touch.",
    "enquireNow": "Enquire now",
    "generalEnquiries": "General enquiries",
    "salesEnquiries": "Sales enquiries",
    "followUs": "Follow us",
    "ourOffice": "Our Office",
    "viewMap": "View map",
    "ourFactory": "Our Factory",
    "address": {
      "full": "Temes u. 18, 3528 Miskolc, HUNGARY",
      "label": "Address"
    },
    "phone": {
      "number": "(+381) 69 220 7072",
      "label": "Phone"
    },
    "officeDescription": "With a extensive experiences working in hospitality and customer service, our team is dedicated to providing a seamless experience from start to finish.",
    "factoryDescription": "Located in contact HUB in Miskolc, our factory is equipped with the latest in manufacturing technology to deliver high-quality modular homes and structures.",
    "name": "Name",
    "email": "Email",
    "message": "Message",
    "formPhone": "Phone",
    "formAddress": "Address",
    "send": "Send Message"
  },
  "enquiry": {
    "formTitle": "Enquiry Form",
    "generalEnquiry": "General Enquiry",
    "specificProduct": "If you want to submit specific product enquiry, navigate to product page.",
    "privacyConsent": "I agree to the processing of my personal data in accordance with the Privacy Policy *"
  },
  "home": {
    "featuredHomes": {
      "natura": {
        "name": "Natura",
        "description": "Eco-Friendly, Modern Comfort"
      },
      "sensa": {
        "name": "Sensa",
        "description": "Spacious Views, Open Living"
      }
    },
    "hero": {
      "title": "Premium Living, Anywhere You Go",
      "subtitle": "Discover our range of premium mobile homes and products"
    },
    "intro": "Welcome to MZM Homes, where innovative design meets sustainable construction.",
    "intro2": "We harness the power of offsite manufacturing to deliver bespoke modular homes and other projects.",
    "mobileHomes": {
      "title": "Mobile homes",
      "description": "Explore our collection of expertly crafted modular homes, designed for comfort, style, and flexibility. Built to suit any lifestyle, these homes offer luxury living with the freedom to go wherever life takes you."
    },
    "otherProducts": {
      "title": "Other products",
      "description": "Discover our range of adaptable structures, including garages, carports, containers and terraces, designed to complement any home. Each product combines durability and style, creating functional spaces."
    },
    "featuredProducts": {
      "garages": {
        "name": "Garages",
        "description": "Durable, stylish solutions to protect your vehicles while enhancing your property."
      },
      "carports": {
        "name": "Carports",
        "description": "Open-air vehicle protection solutions that combine durability with accessibility."
      },
      "containers": {
        "name": "Containers",
        "description": "Explore our versatile container solutions, designed for durability and endless possibilities."
      },
      "outdoorKitchens": {
        "name": "Outdoor Kitchens",
        "description": "Transform your outdoor space with our stylish and functional outdoor kitchen solutions."
      },
      "garbageBins": {
        "name": "Garbage Bins",
        "description": "Practical and stylish solutions for waste management."
      }
    },
    "testimonials": {
      "title": "Customer stories",
      "description": "Our commitment to quality and personalized service has made a lasting impression. Discover how our modular homes and structures have transformed their living spaces and enhanced their lifestyles."
    },
    "loading": "Loading",
    "enquireNow": "Enquire now"
  },
  "products": {
    "loading": "Loading products...",
    "title": "Other products",
    "description": "Discover our range of adaptable structures, including garages, carports, containers and terraces, designed to complement any home. Each product combines durability and style, creating functional spaces.",
    "viewAll": "View all",
    "noProducts": "No products available at the moment. Please check back later.",
    "categoriesTitle": "Product Categories",
    "categoriesObject": {
      "title": "Product Categories",
      "list": {
        "garagesCarports": {
          "name": "Garages & Carports",
          "description": "Durable, stylish solutions to protect your vehicles while enhancing your property. Designed for both functionality and aesthetic appeal, these structures offer the perfect blend of security and elegance."
        },
        "containers": {
          "name": "Containers",
          "description": "Explore our versatile container solutions, designed for durability and endless possibilities. Whether for storage, transportation, or custom projects, our containers offer reliable, flexible options to meet your unique needs."
        },
        "outdoorKitchens": {
          "name": "Outdoor Kitchens",
          "description": "Transform your outdoor space with our stylish and functional outdoor kitchen solutions. Perfect for entertaining guests or enjoying family meals in the fresh air."
        },
        "garbageBins": {
          "name": "Garbage Bins",
          "description": "Practical and stylish solutions for waste management. Our garbage bin enclosures keep your outdoor space tidy while complementing your home's aesthetic."
        }
      }
    },
    "details": "Product Details",
    "specifications": "Specifications",
    "categories": {
      "garages": {
        "name": "Garages",
        "description": "Durable, stylish solutions to protect your vehicles while enhancing your property. Designed for both functionality and aesthetic appeal, these structures offer the perfect blend of security and elegance."
      },
      "carports": {
        "name": "Carports",
        "description": "Open-air vehicle protection solutions that combine durability with accessibility. Our carports offer reliable shelter for your vehicles while maintaining an open design that integrates seamlessly with your property."
      },
      "containers": {
        "name": "Containers",
        "description": "Explore our versatile container solutions, designed for durability and endless possibilities. Whether for storage, transportation, or custom projects, our containers offer reliable, flexible options to meet your unique needs."
      },
      "outdoorKitchens": {
        "name": "Outdoor Kitchens",
        "description": "Transform your outdoor space with our stylish and functional outdoor kitchen solutions. Perfect for entertaining guests or enjoying family meals in the fresh air."
      },
      "garbageBins": {
        "name": "Garbage Bins",
        "description": "Practical and stylish solutions for waste management. Our garbage bin enclosures keep your outdoor space tidy while complementing your home's aesthetic."
      }
    },
    "categoryDetails": {
      "garagesCarports": {
        "name": "Garages & Carports",
        "description": "Durable, stylish solutions to protect your vehicles while enhancing your property. Designed for both functionality and aesthetic appeal, these structures offer the perfect blend of security and elegance."
      },
      "containers": {
        "name": "Containers",
        "description": "Explore our versatile container solutions, designed for durability and endless possibilities. Whether for storage, transportation, or custom projects, our containers offer reliable, flexible options to meet your unique needs."
      },
      "outdoorKitchens": {
        "name": "Outdoor Kitchens",
        "description": "Transform your outdoor space with our stylish and functional outdoor kitchen solutions. Perfect for entertaining guests or enjoying family meals in the fresh air."
      },
      "garbageBins": {
        "name": "Garbage Bins",
        "description": "Practical and stylish solutions for waste management. Our garbage bin enclosures keep your outdoor space tidy while complementing your home's aesthetic."
      }
    },
    "garages": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Compact and functional garage for a single vehicle"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Spacious garage solution for multiple vehicles"
      },
      "garageWithCarport": {
        "name": "Garage with Carport",
        "description": "Combined solution with enclosed garage and attached carport"
      }
    },
    "carports": {
      "carport6x3": {
        "name": "Carport 6x3",
        "description": "Open-air vehicle protection with durable construction"
      },
      "carport6x6": {
        "name": "Carport 6x6",
        "description": "Spacious open-air shelter for multiple vehicles"
      }
    },
    "containers": {
      "basic": {
        "name": "BASIC Container",
        "description": "Simple, durable storage solution for various needs"
      },
      "premium": {
        "name": "PREMIUM Container",
        "description": "Enhanced container with additional features and superior quality"
      }
    },
    "outdoorKitchens": {
      "basic": {
        "name": "BASIC Outdoor Kitchen",
        "description": "Simple and functional outdoor kitchen solution"
      },
      "premium": {
        "name": "PREMIUM Outdoor Kitchen",
        "description": "Luxury outdoor kitchen with premium features"
      }
    },
    "garbageBins": {
      "basic": {
        "name": "BASIC Garbage Bin Storage",
        "description": "Simple and functional garbage bin solution"
      },
      "premium": {
        "name": "PREMIUM Garbage Bin Storage",
        "description": "Enhanced garbage bin solution with premium features"
      }
    },
    "items": {
      "garage6x3": {
        "name": "Garage 6x3",
        "description": "Compact and functional garage for a single vehicle"
      },
      "garage6x6": {
        "name": "Garage 6x6",
        "description": "Spacious garage solution for multiple vehicles"
      },
      "garageWithCarport": {
        "name": "Garage with Carport",
        "description": "Combined solution with enclosed garage and attached carport"
      },
      "basicContainer": {
        "name": "BASIC Container",
        "description": "Simple, durable storage solution for various needs"
      },
      "premiumContainer": {
        "name": "PREMIUM Container",
        "description": "Enhanced container with additional features and superior quality"
      },
      "basicKitchen": {
        "name": "BASIC Outdoor Kitchen",
        "description": "Simple and functional outdoor kitchen solution"
      },
      "premiumKitchen": {
        "name": "PREMIUM Outdoor Kitchen",
        "description": "Luxury outdoor kitchen with premium features"
      },
      "basicBin": {
        "name": "BASIC Garbage Bin Storage",
        "description": "Simple and functional garbage bin solution"
      },
      "premiumBin": {
        "name": "PREMIUM Garbage Bin Storage",
        "description": "Enhanced garbage bin solution with premium features"
      }
    }
  },
  "about": {
    "loading": "Loading about page...",
    "title": "About Us",
    "whoWeAre": "Who We Are",
    "jumpTo": "Jump to",
    "meetTheTeam": "Meet The Team",
    "team": "Our Team",
    "history": "Our History",
    "mission": "Our Mission",
    "part1": {
      "title": "MZM Homes was established in 2024 by people who value design, innovation and sustainability.",
      "description": "As one of Slovenia's leading experts in offsite construction, we spend more time considering how to build better, smarter, and faster."
    },
    "part2": {
      "title": "Our approach harnesses the latest in manufacturing technology, ensuring precision, durability, and a significantly reduced environmental footprint.",
      "description": "We also champion local materials and suppliers to deliver exceptional solutions that are sustainably-minded."
    },
    "part3": {
      "title": "Each MZM Homes project is the result of a unique and proven approach, demonstrated across more than 100 completed homes and other structures",
      "description": "Our turn-key service and transparent pricing model allows for a smooth transition from drawing board to doorstep, making the journey as seamless as it is transformative."
    }
  },
  "blog": {
    "latestPosts": "Latest Posts",
    "readMore": "Read More",
    "postedOn": "Posted on"
  },
  "footer": {
    "salesEnquiries": "Sales Enquiries",
    "generalEnquiries": "General Enquiries",
    "followUs": "Follow us",
    "office": "MZM Office",
    "factory": "MZM Factory",
    "pages": "Pages",
    "products": "Products",
    "homePage": "Home page",
    "garages": "Garages",
    "carports": "Carports",
    "containers": "Containers",
    "kitchens": "Kitchens",
    "garbageBins": "Garbage Bins",
    "rights": "All Rights Reserved",
    "copyright": "© {year} MZM Homes. All rights reserved.",
    "sitemap": "Sitemap",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "cookies": "Cookie Policy",
    "social": {
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "facebook": "Facebook"
    }
  },
  
  "cookies": {
    "title": "Cookie Consent",
    "description": "We use cookies to improve your experience on our website. Some cookies are necessary for the website to function properly, while others help us understand how you interact with our site and allow us to improve it.",
    "moreInfo": "For more information, please read our Cookie Policy.",
    "shortNotice": "We use cookies to improve your experience.",
    "details": "Details",
    "buttonText": "Cookies",
    "customize": "Customize",
    "acceptNecessary": "Accept Necessary Only",
    "acceptAll": "Accept All",
    "preferences": "Cookie Preferences",
    "preferencesDescription": "You can customize your cookie preferences here. Necessary cookies are always enabled as they are essential for the website to function properly.",
    "back": "Back",
    "savePreferences": "Save Preferences",
    "necessary": {
      "title": "Necessary Cookies",
      "description": "These cookies are essential for the website to function properly and cannot be disabled."
    },
    "analytics": {
      "title": "Analytics Cookies",
      "description": "These cookies help us understand how visitors interact with our website, allowing us to improve it."
    },
    "marketing": {
      "title": "Marketing Cookies",
      "description": "These cookies are used to track visitors across websites to display relevant advertisements."
    },
    "preferences": {
      "title": "Preferences Cookies",
      "description": "These cookies enable personalized features and functionality on our website."
    }
  },

  "homes": {
    "loading": "Loading home models...",
    "gallery": {
      "loading": "Loading images..."
    },
    "title": "Mobile homes",
    "description": "Our exclusive collection of four expertly designed house models, each offering a unique blend of style, functionality, and craftsmanship. From eco-friendly innovations to spacious, luxurious living spaces, our homes are tailored to suit diverse tastes and lifestyles.",
    "error": {
      "title": "Oops! Something went wrong",
      "message": "We couldn't find the home models you're looking for.",
      "backButton": "Back to Home"
    },
    "naturaLine": {
      "title": "Natura line",
      "description": "Introducing the Natura line—where sustainability meets modern luxury. Designed with eco-conscious materials and energy-efficient features, these homes offer a perfect balance of style, comfort, and environmental responsibility."
    },
    "sensaLine": {
      "title": "Sensa line",
      "description": "Introducing the Sensa line—elevating your living experience with spacious, open designs and breathtaking views. These homes combine contemporary elegance with functionality, creating the perfect setting for modern living."
    },
    "noResults": "No home models found. Please check back later.",
    "specifications": {
      "ceilingHeight": "Ceiling Height",
      "windows": "Windows",
      "terrace": "Terrace",
      "wallRoofInsulation": "Wall & Roof Insulation",
      "floorInsulation": "Floor Insulation",
      "energyRating": "Energy Rating"
    },
    "models": {
      "naturaMini": {
        "name": "Natura Mini",
        "description": "Eco-friendly design with modern comfort and energy efficiency.",
        "longDescription": "The Natura Mini is our flagship eco-friendly home, designed with sustainability in mind without compromising on comfort or style. Featuring energy-efficient systems, sustainable materials, and smart home technology, this model represents the future of responsible living. The open floor plan creates a spacious feel while maximizing the use of natural light."
      },
      "naturaMaxi": {
        "name": "Natura Maxi",
        "description": "Expanded eco-friendly home with additional space for families.",
        "longDescription": "The Natura Maxi is our larger eco-friendly home, offering additional space for families while maintaining the same commitment to sustainability and quality. With more bedrooms and living space, this model is perfect for those who need extra room without compromising on environmental values."
      },
      "sensaMini": {
        "name": "Sensa Mini",
        "description": "Spacious design with large windows for stunning views.",
        "longDescription": "The Sensa Mini is designed to maximize your connection with the surrounding environment through its expansive windows and open concept living spaces. Perfect for scenic locations, this home brings the outdoors in while providing all the comforts of modern living. Luxury finishes and thoughtful design elements create a sophisticated yet comfortable atmosphere."
      },
      "sensaMaxi": {
        "name": "Sensa Maxi",
        "description": "Our largest panoramic home with premium features and space.",
        "longDescription": "The Sensa Maxi is our most spacious model, offering expansive living areas and premium features. With its large windows and open design, this home creates a seamless connection with the outdoors while providing all the luxury and comfort you could desire. Perfect for those who want to make a statement."
      }
    },
    "features": {
      "energyEfficient": "Energy-efficient design",
      "sustainableMaterials": "Sustainable materials",
      "smartHome": "Smart home technology",
      "openFloorPlan": "Open floor plan",
      "familySized": "Family-sized layout",
      "additionalStorage": "Additional storage",
      "floorToCeiling": "Floor-to-ceiling windows",
      "openConcept": "Open concept living",
      "luxuryFinishes": "Luxury finishes",
      "indoorOutdoor": "Indoor-outdoor flow",
      "premiumFinishes": "Premium finishes",
      "spaciousMaster": "Spacious master suite",
      "multipleLiving": "Multiple living areas",
      "homeOffice": "Home office space",
      "designerKitchen": "Designer kitchen",
      "optionalDeck": "Optional deck extensions",
      "ledLighting": "LED lighting throughout",
      "waterSaving": "Water-saving fixtures",
      "insulationEnergy": {
        "insulation": {
          "highQuality": "High-quality insulation"
        }
      }
    },
    "includedFeatures": {
      "title": "What's included?",
      "headers": {
        "centralSpace": "Central Space",
        "bathroomBedrooms": "Bathroom & Bedrooms",
        "outside": "Outside"
      },
      "centralSpace": {
        "kitchen": "Kitchen with induction cooktop",
        "refrigerator": "Refrigerator",
        "sofa": "Extendable sofa",
        "tv": "LCD TV",
        "table": "Table",
        "chairs": "4 Chairs"
      },
      "bathroomBedrooms": {
        "waterHeater": "Water heater",
        "bathroom": "Complete bathroom unit",
        "toilet": "Toilet",
        "shower": "Shower cabin",
        "bedBase": "Latoflex bed base",
        "mattress": "Mattress",
        "wardrobe": "Wardrobe and shelves"
      },
      "outside": {
        "windows": "Panoramic windows for stunning views",
        "heatingCable": "Heating cable for outdoor water connection",
        "protection": "Protection for installations",
        "terrace": "Terrace (3x8m) made of galvanized profiles and covered with sandwich panels",
        "wallRoof": "Wall & Roof: 10 cm (W/mK = 0.22)",
        "decorativePanels": "Decorative wooden panels made of galvanized steel sheet"
      }
    },
    "details": {
      "bedrooms": "Bedrooms",
      "kitchen": "Kitchen",
      "bathrooms": "Bathrooms",
      "area": "Area",
      "terrace": "Terrace",
      "moreSpecifications": "More specifications",
      "enquireAbout": "Enquire about this home",
      "insulationEnergy": "Insulation & Energy Efficiency",
      "insulation": "Insulation",
      "energyFeatures": "Energy Features",
      "premiumFeatures": "Premium Features",
      "availableAsOption": "Available as option",
      "floorPlans": "Floor plan",
      "floorPlansDescription": "Explore our thoughtfully designed floor plans, tailored to fit a variety of lifestyles. Each layout maximizes space, comfort, and functionality, offering the perfect foundation for your dream home.",
      "otherModels": "Other home models",
      "otherModelsDescription": "Explore our collection of expertly crafted modular homes, designed for comfort, style, and flexibility. Built to suit any lifestyle, these homes offer luxury living with the freedom to go wherever life takes you.",
      "garagesDescription": "Secure Storage, Sleek Design",
      "containersDescription": "Flexible, Durable Solutions",
      "homeGardenDescription": "Elegant Living, Outdoor Bliss"
    },
    "insulationEnergy": {
      "insulation": {
        "wallRoof": "Wall & Roof: 10cm (W/mK = 0.22)",
        "floor": "Floor: 12cm insulation",
        "windows": "Windows: Ug = 1.1 W/m²K",
        "doubleGlazed": "Double-glazed windows",
        "thermalBreak": "Thermal break system",
        "highQuality": "High-quality insulation"
      },
      "energyFeatures": {
        "solarReady": "Solar panel ready",
        "ledLighting": "LED lighting throughout",
        "efficientAppliances": "Energy-efficient appliances"
      }
    },
    "premiumFeatures": {
      "panoramicWindows": "Panoramic windows for stunning views",
      "flexibility": "Flexibility and mobility",
      "qualityMaterials": "High-quality materials",
      "energyEfficiency": "Energy efficiency",
      "aestheticAppeal": "Aesthetic appeal",
      "customization": "Customization",
      "fastMoveIn": "Fast move-in",
      "idealRental": "Ideal for rental",
      "lowMaintenance": "Low maintenance costs",
      "privacy": "Privacy and tranquility",
      "compactDesign": "Compact and spacious design"
    },
    "genericModel": {
      "name": "Home Model",
      "description": "Modern modular home design.",
      "longDescription": "This model offers the perfect balance of comfort, style, and functionality. Designed with modern living in mind, it features open spaces, quality materials, and energy-efficient solutions.",
      "features": {
        "modernDesign": "Modern design",
        "qualityMaterials": "Quality materials",
        "energyEfficiency": "Energy efficiency",
        "customizableOptions": "Customizable options"
      }
    }
  },

  "breadcrumb": {
    "home": "Home",
    "mobileHomes": "Mobile Homes",
    "products": "Other Products",
    "about": "About Us",
    "contact": "Contact",
    "blog": "Blog",
    "garages": "Garages",
    "containers": "Containers",
    "homeGarden": "Home & Garden"
  },

  "productDetails": {
    "common": {
      "otherProducts": "Other products",
      "otherProductsDescription": "Discover our range of adaptable structures, including garages, carports, containers and terraces, designed to complement any home. Each product combines durability and style, creating functional spaces.",
      "enquiryForm": "Enquiry Form",
      "enquiringAbout": "You are enquiring about:",
      "generalEnquiry": "If you want to submit a general enquiry, click here."
    },
    "garages": {
      "loading": "Loading garage details...",
      "error": {
        "title": "Oops! Something went wrong",
        "message": "We couldn't find the garage you're looking for.",
        "backButton": "Back to Garages"
      },
      "dimensions": "Dimensions:",
      "area": "Area:",
      "height": "Height:",
      "doorWidth": "Door Width:",
      "doorHeight": "Door Height:",
      "moreSpecifications": "More Specifications",
      "materials": "Materials",
      "qualityMaterials": "Quality Materials",
      "additionalFeatures": "Additional Features",
      "features": "Features",
      "customizationOptions": "Customization Options",
      "otherModels": "Other Garage Models",
      "otherModelsDescription": "Explore our selection of garage solutions designed for durability, functionality, and style. Each model offers secure storage for your vehicles and equipment.",
      "enquireButton": "Enquire",
      "enquireAbout": "Enquire about this garage",
      "openGallery": "Open gallery",
      "price": "Price:"
    },
    "containers": {
      "loading": "Loading container details...",
      "error": {
        "title": "Oops! Something went wrong",
        "message": "We couldn't find the container you're looking for.",
        "backButton": "Back to Containers"
      },
      "dimensions": "Dimensions:",
      "area": "Area:",
      "height": "Height:",
      "doorWidth": "Door Width:",
      "doorHeight": "Door Height:",
      "moreSpecifications": "More Specifications",
      "materials": "Materials",
      "qualityMaterials": "Quality Materials",
      "additionalFeatures": "Additional Features",
      "features": "Features",
      "customizationOptions": "Customization Options",
      "otherModels": "Other Container Models",
      "otherModelsDescription": "Explore our selection of container solutions designed for versatility, durability, and functionality. Each model offers flexible space for various applications.",
      "enquireButton": "Enquire",
      "enquireAbout": "Enquire about this container",
      "openGallery": "Open gallery",
      "price": "Price:"
    },
    "outdoorKitchens": {
      "loading": "Loading outdoor kitchen details...",
      "error": {
        "title": "Oops! Something went wrong",
        "message": "We couldn't find the outdoor kitchen you're looking for.",
        "backButton": "Back to Outdoor Kitchens"
      },
      "dimensions": "Dimensions:",
      "area": "Area:",
      "height": "Height:",
      "moreSpecifications": "More Specifications",
      "materials": "Materials",
      "qualityMaterials": "Quality Materials",
      "additionalFeatures": "Additional Features",
      "features": "Features",
      "customizationOptions": "Customization Options",
      "otherModels": "Other Outdoor Kitchen Models",
      "otherModelsDescription": "Explore our selection of outdoor kitchen solutions designed for style, functionality, and durability. Each model offers a perfect space for cooking and entertaining outdoors.",
      "enquireButton": "Enquire",
      "enquireAbout": "Enquire about this outdoor kitchen",
      "openGallery": "Open gallery",
      "price": "Price:"
    },
    "garbageBins": {
      "loading": "Loading garbage bin details...",
      "error": {
        "title": "Oops! Something went wrong",
        "message": "We couldn't find the garbage bin you're looking for.",
        "backButton": "Back to Garbage Bins"
      },
      "dimensions": "Dimensions:",
      "area": "Area:",
      "height": "Height:",
      "moreSpecifications": "More Specifications",
      "materials": "Materials",
      "qualityMaterials": "Quality Materials",
      "additionalFeatures": "Additional Features",
      "features": "Features",
      "customizationOptions": "Customization Options",
      "otherModels": "Other Garbage Bin Models",
      "otherModelsDescription": "Explore our selection of garbage bin solutions designed for practicality, durability, and style. Each model offers efficient waste management while complementing your property.",
      "enquireButton": "Enquire",
      "enquireAbout": "Enquire about this garbage bin",
      "openGallery": "Open gallery",
      "price": "Price:"
    },
    "enquiryForm": "Enquiry Form",
    "enquiringAbout": "You are enquiring about:",
    "generalEnquiry": "If you want to submit a general enquiry, click here."
  }
}
